import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE_class_variance_authority_159ad65c__ from "class-variance-authority";
import * as __WEBPACK_EXTERNAL_MODULE__Icon_module_js_01cb08e6__ from "./Icon.module.js";
const iconClass = (0, __WEBPACK_EXTERNAL_MODULE_class_variance_authority_159ad65c__.cva)('', {
    variants: {
        size: {
            50: __WEBPACK_EXTERNAL_MODULE__Icon_module_js_01cb08e6__["default"].size50,
            75: __WEBPACK_EXTERNAL_MODULE__Icon_module_js_01cb08e6__["default"].size75,
            100: __WEBPACK_EXTERNAL_MODULE__Icon_module_js_01cb08e6__["default"].size100,
            150: __WEBPACK_EXTERNAL_MODULE__Icon_module_js_01cb08e6__["default"].size150,
            200: __WEBPACK_EXTERNAL_MODULE__Icon_module_js_01cb08e6__["default"].size200,
            300: __WEBPACK_EXTERNAL_MODULE__Icon_module_js_01cb08e6__["default"].size300,
            400: __WEBPACK_EXTERNAL_MODULE__Icon_module_js_01cb08e6__["default"].size400,
            500: __WEBPACK_EXTERNAL_MODULE__Icon_module_js_01cb08e6__["default"].size500,
            625: __WEBPACK_EXTERNAL_MODULE__Icon_module_js_01cb08e6__["default"].size625,
            750: __WEBPACK_EXTERNAL_MODULE__Icon_module_js_01cb08e6__["default"].size750
        }
    },
    defaultVariants: {
        size: '100'
    }
});
const iconSizeOptions = [
    '50',
    '75',
    '100',
    '150',
    '200',
    '300',
    '400',
    '500',
    '625',
    '750'
];
function Icon({ iconUrl, size }) {
    if (!iconUrl) return null;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("img", {
        src: iconUrl,
        alt: "",
        className: iconClass({
            size: size
        })
    });
}
const Icon_rslib_entry_ = Icon;
export { Icon_rslib_entry_ as default, iconClass, iconSizeOptions };

//# sourceMappingURL=Icon.js.map